import React from 'react'
import {TwitterTweetEmbed} from "react-twitter-embed";

import { Row, Col, Container} from 'react-bootstrap';

import Loader from './Loader';

function Testimonials() {
    return (
         <Container>
        <Row className='d-flex justify-content-center align-content-center align-items-start my-5'>
               <Col>
                    <TwitterTweetEmbed tweetId="1346735691334627329" placeholder={<Loader />} />
               </Col> 
               <Col>
                    <TwitterTweetEmbed tweetId="1392597771761291264" placeholder={<Loader />} />
               </Col>
               <Col>
                    <TwitterTweetEmbed tweetId="1378201217403297797" placeholder={<Loader />} />
               </Col> 
        </Row>
        <Row className='d-flex justify-content-center align-content-center align-items-start my-5'> 
               <Col>
                    <TwitterTweetEmbed tweetId="1349306409721204737" placeholder={<Loader />} />
               </Col> 
               <Col>
                    <TwitterTweetEmbed tweetId="1662123300061949953" placeholder={<Loader />} />
               </Col> 
        </Row>
        </Container>
    )
}

export default Testimonials;